import {ChangeDetectionStrategy, Component, computed} from "@angular/core"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {ValueSlotComponent} from "@template-editor/components/value-slot/value-slot.component"
import {OutputNode, getTemplateNodeClassLabel, isTemplateNode} from "@cm/template-nodes"
import {mattressComponentInstance, type MattressOutput, MattressComponentInstance} from "@cm/mattress-nodes"

@Component({
    selector: "cm-mattress-output-inspector",
    templateUrl: "./mattress-output-inspector.component.html",
    styleUrl: "./mattress-output-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MattressOutputInspectorComponent extends BaseInspectorComponent<MattressOutput | OutputNode> {
    readonly $class = computed(() => getTemplateNodeClassLabel(this.$node()))

    readonly $component = computed(() => {
        const node = this.$node()
        if (node instanceof OutputNode) {
            const templateInstance = node.parameters.template
            const validParents = [...templateInstance.parents].filter((parent) => isTemplateNode(parent) && parent instanceof MattressComponentInstance)
            if (validParents.length === 1) return validParents[0]
            throw new Error("Expected dummy template instance to be parented by a single mattress component instance")
        } else return node.parameters.component
    })

    componentSchema = mattressComponentInstance
}
